import { useState } from "react";
import { FolderPlus, Check, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { uploadDocument } from "../../lib/api";

// Under a photo answer: one tap files the snapped image in the vault with the AI's suggested tags.
export const PhotoFileButton = ({ photo, onFiled }) => {
  const [state, setState] = useState("idle");
  const file = async () => {
    setState("busy");
    try {
      const doc = await uploadDocument(photo.file, "chat", undefined, (photo.tags || []).join(","));
      setState("done");
      toast.success(`Filed as “${doc.title || photo.title}”`);
      onFiled?.(doc);
    } catch (e) {
      setState("idle");
      toast.error(e?.response?.data?.detail || "Couldn't file that photo");
    }
  };
  return (
    <div className="mt-2 flex items-center gap-2 text-[11px]">
      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 ${photo.keep ? "bg-emerald-100 text-emerald-800" : "bg-stone-200 text-stone-700"}`} data-testid="chat-photo-verdict">
        {photo.keep ? <FolderPlus className="h-3 w-3" /> : <Trash2 className="h-3 w-3" />} {photo.keep ? "Worth keeping" : "Safe to toss"}
      </span>
      {state === "done" ? (
        <span data-testid="chat-photo-filed" className="inline-flex items-center gap-1 text-emerald-700"><Check className="h-3 w-3" /> In the vault</span>
      ) : (
        <button data-testid="chat-photo-file-btn" disabled={state === "busy"} onClick={file} className="inline-flex items-center gap-1 rounded-full border border-primary/40 px-2 py-0.5 text-primary hover:bg-primary/5">
          {state === "busy" ? <Loader2 className="h-3 w-3 animate-spin" /> : <FolderPlus className="h-3 w-3" />} File it as {photo.category}
        </button>
      )}
    </div>
  );
};
